import { render, staticRenderFns } from "./AssignComponent.vue?vue&type=template&id=ee5f3888&"
import script from "./AssignComponent.vue?vue&type=script&lang=js&"
export * from "./AssignComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports